import { createSlice } from '@reduxjs/toolkit';

import { getUser } from '@/microfrontends/filters/shared/store/thunks/user';
import { type RequestStatus } from '@/microfrontends/filters/shared/types/RequestStatus';
import { type TUser } from '@/microfrontends/filters/shared/types/user';

export type TUserState = {
  status: RequestStatus;
  data: TUser;
};

const userInitialState: TUserState = {
  status: 'initial',
  data: {
    isAuthenticated: false,
  },
};

export const userSlice = createSlice({
  initialState: { ...userInitialState },
  name: 'user',
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getUser.pending, state => {
        state.status = 'loading';
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.status = 'succeed';
        state.data = action.payload;
      })
      .addCase(getUser.rejected, state => {
        state.status = 'failed';
      });
  },
});

export const { reducer: userReducer, actions: userActions } = userSlice;
